__turbopack_context__.v({
  "accordionSlideOverwrite": "toolsCalculatorsPage-module-scss-module__JUy2HW__accordionSlideOverwrite",
  "fadeIn": "toolsCalculatorsPage-module-scss-module__JUy2HW__fadeIn",
  "fadeOut": "toolsCalculatorsPage-module-scss-module__JUy2HW__fadeOut",
  "scaleIn": "toolsCalculatorsPage-module-scss-module__JUy2HW__scaleIn",
  "scaleOut": "toolsCalculatorsPage-module-scss-module__JUy2HW__scaleOut",
  "toolsCalculatorsPage": "toolsCalculatorsPage-module-scss-module__JUy2HW__toolsCalculatorsPage",
  "zoomIn": "toolsCalculatorsPage-module-scss-module__JUy2HW__zoomIn",
  "zoomOut": "toolsCalculatorsPage-module-scss-module__JUy2HW__zoomOut",
});
